import { FunctionComponent, PropsWithChildren } from 'react';
import React from 'react';
import { CalendarSelectContextProvider } from '../../contexts/CalendarSelectContext';

export type SelectProps = PropsWithChildren<{
    isDaySelected?: (day: { from: Date; to: Date }) => boolean;
    onDaySelected?: (day: { from: Date; to: Date }) => void;
    isDayDisabled?: (day: { from: Date; to: Date }) => boolean;
}>;

export const Select: FunctionComponent<SelectProps> = ({
    isDaySelected = () => false,
    onDaySelected = () => {},
    isDayDisabled = () => false,
    children,
}) => {
    return (
        <CalendarSelectContextProvider
            isDaySelected={isDaySelected}
            onDaySelected={onDaySelected}
            isDayDisabled={isDayDisabled}
        >
            {children}
        </CalendarSelectContextProvider>
    );
};
